import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../App";

const DEFAULT_LOGO_URL = "/logo-marketvalley.png";

const LoadingScreen = ({ message = "Cargando..." }) => {
  const [progress, setProgress] = useState(0);
  const [logoUrl, setLogoUrl] = useState(() => localStorage.getItem('brand_logo_url') || DEFAULT_LOGO_URL);

  useEffect(() => {
    axios.get(`${API}/app-config`)
      .then((res) => {
        if (res.data.logo_url) setLogoUrl(res.data.logo_url);
      })
      .catch(() => {});
  }, []);
  
  useEffect(() => {
    // Simulate loading progress
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 90) {
          clearInterval(interval);
          return 90;
        }
        return prev + Math.random() * 15;
      });
    }, 200);
    
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-[#FAFAF9] to-[#F1F5F9]">
      <div className="flex flex-col items-center gap-6">
        {/* Animated Logo */}
        <div className="relative">
          <div className="absolute inset-0 bg-[#F97316]/20 rounded-full blur-2xl animate-pulse" />
          <img 
            src={logoUrl} 
            alt="Clueer" 
            className="h-12 w-auto relative z-10 animate-bounce"
            style={{ animationDuration: '2s' }}
          />
        </div>
        
        {/* Tagline */}
        <div className="text-center">
          <p className="text-[#64748B] text-sm font-medium tracking-wide">
            Clueer 🇵🇦
          </p>
        </div>
        
        {/* Loading bar */}
        <div className="w-48 h-1 bg-[#E2E8F0] rounded-full overflow-hidden">
          <div 
            className="h-full bg-gradient-to-r from-[#F97316] to-[#EA580C] rounded-full transition-all duration-300 ease-out"
            style={{ width: `${progress}%` }}
          />
        </div>
        
        {/* Loading text */}
        <p className="text-[#94A3B8] text-xs animate-pulse">
          {message}
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;
